import useUrl from 'hooks/useUrl';
import { MediaQueryContext, SiteContext } from 'libs/contexts';
import { trackPV } from 'libs/eTracking';
// import { isOnAliyun } from 'libs/utils';
// import getConfig from 'next/config';
import HTMLHead from 'next/head';
import Router from 'next/router';
import { useContext } from 'react';

// const { publicRuntimeConfig } = getConfig();

export type HeadProps = {
  title: string;
  keywords: string;
  description: string;
};

// const TY_APP_ID = '36847E0A86B5167B852CF20608B584CF';

export default function Head({ title, keywords, description }: HeadProps) {
  const { isMobile } = useContext(MediaQueryContext);
  const site = useContext(SiteContext);
  const { getPublicUrl } = useUrl();
  // const isGa = process.env.ENV === 'zjga';
  const favicon = site?.global?.faviconUrl
    ? getPublicUrl(site?.global?.faviconUrl)
    : '/favicon.ico?t=20211124';
  return (
    <HTMLHead>
      <title>{title}</title>
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      {isMobile ? (
        <>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
        </>
      ) : (
        <meta name="viewport" content="width=1200" />
      )}
      <meta name="renderer" content="webkit" />
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      <link rel="shortcut icon" href={favicon} />

      {/* {isGa && isOnAliyun() && !process.env.PT && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              var _hmt = _hmt || [];
              (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?d58cdc242ccb1a9d7b1f66e71519bd4a";
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(hm, s);
              })();
            `,
          }}
        />
      )} */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            if (window.navigator.userAgent.indexOf("MSIE") >= 0 && window.navigator.userAgent.indexOf("MSIE 1") < 0) {
              window.location.href = "https://static-tg.3jyx.cn/mallfe/browser-upgrade.html?_=20211123"
            }
          `,
        }}
      />
    </HTMLHead>
  );
}

// Router.events.on('routeChangeComplete', () => {
//   // PAD tracking
//   trackPV();
// });
